import { BsPencil, BsTrash, BsPlusCircle, BsSearch } from 'react-icons/bs';
import { Button, Input } from 'ypf-pas-general-ui-components';
import { MdOutlineClose } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import PropTypes from 'prop-types';

import DeleteTemplateModal from '../../../components/DeleteTemplateModal/DeleteTemplateModal';
import './TemplateWorkReport.scss';
import { useWorkReportModals } from '../../../context/WorkReportModalsContext';
import { checkRol } from '../../../security';
import { proveedorNotificador } from '../../../security/constantsRols';

export const ButtonsHeaderTemplate = ({
  checkBoxState,
  isRequestTemplate,
  idRequest,
  isSDS,
  itemCheck,
  isDraw,
  idDraw,
  manageTemplateComponent,
  setNewFetch,
  setModalDeleteHide,
  applyTemplateView,
  goForceReset,
  previusPath,
  disabledButtonGenerateTamplate,
  setIsPublic,
  isPublic,
  templateNameToSearch,
  setTemplateNameToSearch,
  setWithAmount,
  withAmount
}) => {
  const history = useHistory();
  const [modalDeleteTemplate, setModalDeleteTemplate] = useState(false);
  const [alreadyFetched, setAlreadyFetched] = useState(false);

  const { hideModal } = useWorkReportModals();

  const handleDeleteTemplate = () => {
    if (applyTemplateView) setModalDeleteHide(false);
    setModalDeleteTemplate(true);
  };

  const handleOnSumbitDeleteTemplate = () => {
    goForceReset?.current({
      resetPage: 0,
      resetPageSize: 5,
      resetSortBy: []
    });
    setModalDeleteTemplate(false);
    if (applyTemplateView) setModalDeleteHide(true);
    setNewFetch((oldValue) => !oldValue);
  };

  const handleOnClickEditButton = () => {
    if (isRequestTemplate) {
      history.push({
        pathname: `/edit-template/request/${itemCheck[0].id}`,
        previusPath,
        templateToEdit: itemCheck
      });
    } else {
      history.push({
        pathname: `/edit-template/${itemCheck[0].id}`,
        state: itemCheck,
        isSDS
      });
    }
  };

  const handleOnClickCreateTemplate = () => {
    hideModal();
    if (isRequestTemplate && isDraw) {
      history.push({
        pathname: `/generate-template/request`,
        previusPath,
        isDraw,
        idDraw
      });
    }

    if (isRequestTemplate && !isDraw) {
      history.push({
        pathname: `/generate-template/request`,
        previusPath
      });
    }

    // TODO: función para redirigir a Generate
    if (isSDS && !isRequestTemplate) {
      history.push({
        pathname: '/generate-template',
        state: isSDS,
        idRequest
      });
    } else if (!isRequestTemplate) {
      history.push('/generate-template');
    }
  };

  const handleChangeNameTemplate = (value) => {
    setTemplateNameToSearch(value);
  };

  const handleclearNameTemplate = () => {
    setAlreadyFetched(false);
    setTemplateNameToSearch('');
    setNewFetch((oldState) => !oldState);
  };

  const onSubmitSearchTemplate = (e) => {
    e?.preventDefault();
    if (templateNameToSearch.length >= 3) {
      setAlreadyFetched(true);
      setNewFetch((oldState) => !oldState);
    }
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-between ">
        <div className="containers-buttons">
          {manageTemplateComponent && (
            <Button
              className="mx-4"
              colorIcon={checkBoxState?.length === 1 ? 'success' : 'dark'}
              disabled={
                checkBoxState?.length !== 1 ||
                (!itemCheck?.filter((template) => template?.esPropia)?.length && isRequestTemplate)
              }
              icon={BsPencil}
              onClick={handleOnClickEditButton}
              type="button"
              variant="light-gray"
              widthButton="40px"
            />
          )}
          <Button
            className="mx-1"
            colorIcon={checkBoxState?.length !== 0 ? 'danger' : 'dark'}
            disabled={
              checkBoxState?.length === 0 ||
              (!itemCheck?.every((template) => template?.esPropia) && isRequestTemplate)
            }
            icon={BsTrash}
            onClick={handleDeleteTemplate}
            type="button"
            variant="light-gray"
            widthButton="40px"
          />
        </div>
        {checkRol(proveedorNotificador) && (
          <div className="d-flex justify-content-between align-items-center gap-4">
            <div className="d-flex align-items-center space-between gap-2">
              <span>Ver:</span>
              <input
                checked={!withAmount}
                className="radio-label"
                onChange={() => {
                  setWithAmount(false);
                }}
                title="sin-cantidad"
                type="radio"
              />
              Sin Cantidades
              <input
                checked={withAmount}
                className="radio-label"
                onChange={() => {
                  setWithAmount(true);
                }}
                title="con-cantidad"
                type="radio"
              />
              Con Cantidades
            </div>
          </div>
        )}
        {isRequestTemplate && (
          <div className="d-flex justify-content-between align-items-center gap-4">
            <div className="d-flex align-items-center space-between col-sm-3 gap-2">
              <span>ver:</span>
              <input
                checked={!isPublic}
                onChange={() => {
                  setIsPublic(false);
                }}
                type="radio"
              />
              Propias
              <input
                checked={isPublic}
                onChange={() => {
                  setIsPublic(true);
                }}
                type="radio"
              />
              Publicas
            </div>
            <form onSubmit={onSubmitSearchTemplate}>
              <Input
                disabledIcon={templateNameToSearch.length < 3}
                handleClickOnIcon={() => {
                  if (alreadyFetched) {
                    handleclearNameTemplate();
                  } else if (templateNameToSearch.length >= 3) {
                    onSubmitSearchTemplate();
                  }
                }}
                icon={alreadyFetched ? <MdOutlineClose /> : <BsSearch />}
                onChange={(e) => handleChangeNameTemplate(e.target.value)}
                onSearchFunction={onSubmitSearchTemplate}
                placeholder="Buscá por nombre"
                type="text"
                value={templateNameToSearch}
              />
            </form>
          </div>
        )}
        <div className="d-flex justify-content-end my-2">
          <Button
            className="mx-2"
            colorIcon="primary"
            disabled={disabledButtonGenerateTamplate}
            fontSizeLabel="15px"
            icon={BsPlusCircle}
            iconRight
            label="Generar plantilla"
            onClick={handleOnClickCreateTemplate}
            sizeIcon="17px"
            type="button"
            variant="light-gray"
            widthButton="180px"
          />
        </div>
        <DeleteTemplateModal
          applyTemplateView={applyTemplateView}
          dataDeleteTemplate={itemCheck}
          handleOnSubmitDeleteTemplate={handleOnSumbitDeleteTemplate}
          isRequestTemplate={isRequestTemplate}
          modalDeleteTemplate={modalDeleteTemplate}
          setModalDeleteHide={setModalDeleteHide}
          setModalDeleteTemplate={setModalDeleteTemplate}
        />
      </div>
    </>
  );
};

ButtonsHeaderTemplate.propTypes = {
  checkBoxState: PropTypes.arrayOf(PropTypes.number),
  setTemplateNameToSearch: PropTypes.func,
  templateNameToSearch: PropTypes.string,
  isRequestTemplate: PropTypes.bool,
  idRequest: PropTypes.string.isRequired,
  isSDS: PropTypes.bool,
  isDraw: PropTypes.bool,
  idDraw: PropTypes.number,
  previusPath: PropTypes.string.isRequired,
  itemCheck: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number
    })
  ),
  manageTemplateComponent: PropTypes.bool,
  applyTemplateView: PropTypes.bool,
  goForceReset: PropTypes.shape({
    current: PropTypes.func
  }),
  setNewFetch: PropTypes.func,
  setModalDeleteHide: PropTypes.func,
  disabledButtonGenerateTamplate: PropTypes.bool,
  isPublic: PropTypes.bool,
  setIsPublic: PropTypes.func,
  setWithAmount: PropTypes.func,
  withAmount: PropTypes.bool
};

ButtonsHeaderTemplate.defaultProps = {
  applyTemplateView: false,
  checkBoxState: [],
  disabledButtonGenerateTamplate: false,
  goForceReset: {},
  idDraw: null,
  isDraw: false,
  isPublic: false,
  isRequestTemplate: false,
  isSDS: false,
  itemCheck: [],
  manageTemplateComponent: false,
  setIsPublic: () => {},
  setModalDeleteHide: () => {},
  setNewFetch: () => {},
  setTemplateNameToSearch: () => {},
  templateNameToSearch: '',
  setWithAmount: () => {},
  withAmount: false
};

export default ButtonsHeaderTemplate;
